import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "checkout_state";

const load = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const save = (state) => {
  try {
    const toSave = {
      shippingAddress: state.shippingAddress,
      billingAddress: state.billingAddress,
      billingSameAsShipping: state.billingSameAsShipping,
      paymentMethod: state.paymentMethod,
      region: state.region,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave));
  } catch {
    // ignore
  }
};

const saved = load();

const initialState = {
  shippingAddress: saved?.shippingAddress || null,
  billingAddress: saved?.billingAddress || null,
  billingSameAsShipping:
    saved?.billingSameAsShipping !== undefined ? saved.billingSameAsShipping : true,
  paymentMethod: saved?.paymentMethod || null,
  region: saved?.region || "BD",
};

const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    setShippingAddress(state, action) {
      state.shippingAddress = action.payload;
      if (state.billingSameAsShipping) {
        state.billingAddress = action.payload;
      }
      save(state);
    },
    setBillingSameAsShipping(state, action) {
      state.billingSameAsShipping = Boolean(action.payload);
      if (state.billingSameAsShipping) {
        state.billingAddress = state.shippingAddress;
      }
      save(state);
    },
    setBillingAddress(state, action) {
      state.billingAddress = action.payload;
      save(state);
    },
    setPaymentMethod(state, action) {
      state.paymentMethod = action.payload;
      save(state);
    },
    setRegion(state, action) {
      state.region = action.payload;
      save(state);
    },
    clearCheckout(state) {
      state.shippingAddress = null;
      state.billingAddress = null;
      state.billingSameAsShipping = true;
      state.paymentMethod = null;
      state.region = "BD";
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch {
        // ignore
      }
    },
  },
});

export const {
  setShippingAddress,
  setBillingSameAsShipping,
  setBillingAddress,
  setPaymentMethod,
  setRegion,
  clearCheckout,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
